const { isDesktop } = require('@/functions/screen');

const focusElement = (element, onMobile = true, onDesktop = true) => {
    const desktop = isDesktop();
    if ((desktop && !onDesktop) || (!desktop && !onMobile)) {
        return;
    }

    element.focus();
};

/**
 * @param {HTMLInputElement} element
 * @param onMobile
 * @param onDesktop
 */
const selectTextInElement = (element, onMobile = true, onDesktop = true) => {
    const desktop = isDesktop();
    if ((desktop && !onDesktop) || (!desktop && !onMobile)) {
        return;
    }

    element.select();
    element.setSelectionRange(0, element.value.length);
};

/**
 * @param {HTMLInputElement} element
 * @param onMobile
 * @param onDesktop
 */
const blurElement = (element, onMobile = true, onDesktop = true) => {
    const desktop = isDesktop();
    if ((desktop && !onDesktop) || (!desktop && !onMobile)) {
        return;
    }

    element.blur();
};

/**
 * @param {HTMLElement} el
 * @param {HTMLElement} holder
 * @return {boolean}
 */
const isElementVisible = (el, holder) => {
    holder = holder || document.body;
    const { top, bottom } = el.getBoundingClientRect();
    const holderRect = holder.getBoundingClientRect();

    return top >= holderRect.top && bottom <= holderRect.bottom;
};

/**
 * Scrolls a scrollable container so that a target element is positioned
 * at the top of the scrollable area. It dynamically adds an invisible spacer
 * to ensure enough scrollable height, if needed.
 *
 * @param {HTMLElement} elementToScroll The DOM element we want to scroll to.
 * @param {HTMLElement} scrollableContainer The DOM element that can be scrolled.
 * @param {String} scrollSpacerClassName The name of the class to identify the spacer element.
 */
const scrollElementInContainer = (elementToScroll, scrollableContainer, scrollSpacerClassName = 'scroll-spacer') => {
    // Append a temporary spacer element if it does not already exist.
    let spacer = document.querySelector(`.${scrollSpacerClassName}`);
    if (!spacer) {
        spacer = document.createElement('div');
        spacer.className = scrollSpacerClassName;
        spacer.style.width = '1px';
        spacer.style.visibility = 'hidden';
        scrollableContainer.appendChild(spacer);
    }

    // Temporarily set spacer height to 0px to ensure that the calculation of 'currentMaxScrollTop' reflects
    // the scrollable height of the actual content without the spacer.
    spacer.style.height = '0px';

    const targetScrollTop = (
        elementToScroll.getBoundingClientRect().top
        - scrollableContainer.getBoundingClientRect().top // minus
        + scrollableContainer.scrollTop
        - 10 // minus a small bit of padding.
    );

    // The maximum scroll position possible with the current content.
    // Important: if the scrollableContainer is being stretched with flex-grow: 1 then it is important that you have
    // an immediate child with a height of 100% to make the stretched height real for scrolling purposes.
    const currentMaxScrollTop = scrollableContainer.scrollHeight - scrollableContainer.clientHeight;

    // We need to add extra space to make the scroll possible.
    // This happens if the target element's offsetTop is greater than the current maximum scroll position.
    let neededExtraSpace = 0;
    if (targetScrollTop > currentMaxScrollTop) {
        neededExtraSpace = targetScrollTop + currentMaxScrollTop;
    }

    // Set the height of the spacer to provide the needed extra scrollable space + a small adjustment of 20px;
    spacer.style.height = `${neededExtraSpace > 0 ? neededExtraSpace + 20 : 0}px`;

    // Perform the scroll action on the scrollableContainer.
    scrollableContainer.scrollTo({
        top: targetScrollTop, // Scroll to the calculated position
        behavior: 'smooth', // Provides a smooth animation for the scroll
    });

    // Note: we can't just remove the spacer because otherwise everything will scroll back.
};

module.exports = {
    blurElement,
    focusElement,
    isElementVisible,
    scrollElementInContainer,
    selectTextInElement,
};
